import { TabContext } from '@mui/lab';
import { Drawer, createDrawer } from '@nexelem/drawer';
import { DetailsTab, DetailsTabList } from '@nexelem/tabs';
import { SyntheticEvent, useState } from 'react';
import { TasksSettingsTab } from './TasksSettingsTab';
import { useCustomTranslation } from '../../../../../hooks/useCustomTranslation';
import { QueuesSettingsTab } from './QueuesSettingsTab';

enum Tabs {
  Queues = 'Settings',
  Tasks = 'Tasks',
}

const ProductionPlanSettingsDrawer = () => {
  const { tWrapper } = useCustomTranslation('products.productionPlan.settingDrawer');
  const [currentTab, setCurrentTab] = useState(Tabs.Queues);

  const handleChange = (_: SyntheticEvent, newValue: Tabs) => {
    setCurrentTab(newValue);
  };

  return (
    <TabContext value={currentTab}>
      <Drawer>
        <Drawer.Header
          title={<div className="text-t24-sb">{tWrapper('title')}</div>}
          tabs={
            <DetailsTabList variant="fullWidth" onChange={handleChange}>
              <DetailsTab label={tWrapper('queues')} value={Tabs.Queues} />
              <DetailsTab label={tWrapper('tasks')} value={Tabs.Tasks} />
            </DetailsTabList>
          }
          onClose={closeProductionPlanSettingsDrawer}
        />
        <Drawer.Panel value={Tabs.Queues}>
          <QueuesSettingsTab />
        </Drawer.Panel>
        <Drawer.Panel value={Tabs.Tasks}>
          <TasksSettingsTab />
        </Drawer.Panel>
      </Drawer>
    </TabContext>
  );
};

export const { toggleProductionPlanSettingsDrawer, closeProductionPlanSettingsDrawer } = createDrawer(
  ProductionPlanSettingsDrawer,
  {
    name: 'ProductionPlanSettingsDrawer',
    width: 420,
    slot: 'left',
    drawerId: () => 'production-plan-settings-drawer',
  },
);
